// hjjcn prod
const url = {
  lambda: {
    /* 專案後端api */
    academy:
      'https://rctj2kyewa.execute-api.cn-north-1.amazonaws.com.cn/prod/academy/',
    subAcademy:
      'https://rctj2kyewa.execute-api.cn-north-1.amazonaws.com.cn/prod/subacademy/',
    academy2:
      'https://qedve6jnil.execute-api.cn-north-1.amazonaws.com.cn/prod/academy2/',
    aiCourse:
      'https://aul7oeitxi.execute-api.cn-north-1.amazonaws.com.cn/prod/aiCourse/',
    aiGame:
      'https://eoqe6um7hg.execute-api.cn-north-1.amazonaws.com.cn/prod/aiGame/',
    announcement:
      'https://61jrn8jpwg.execute-api.cn-north-1.amazonaws.com.cn/prod/announcement/',
    notification:
      'https://b17rl74ft6.execute-api.cn-north-1.amazonaws.com.cn/prod/notification/',
    tsumeGame:
      'https://4zwv0vsyhf.execute-api.cn-north-1.amazonaws.com.cn/prod/tsumeGame/',
    user: 'https://rjo8ni4a4e.execute-api.cn-north-1.amazonaws.com.cn/prod/user/',
    password:
      'https://rjo8ni4a4e.execute-api.cn-north-1.amazonaws.com.cn/prod/password/',
    socket: 'wss://cg85k3v7j8.execute-api.cn-north-1.amazonaws.com.cn/prod/',
    maintenance:
      'https://h9wh5a98ai.execute-api.cn-north-1.amazonaws.com.cn/prod/maintenance/',
    backstage:
      'https://ex663f8dhc.execute-api.cn-north-1.amazonaws.com.cn/prod/backstage/',
    pvp: 'https://necklxpd28.execute-api.cn-north-1.amazonaws.com.cn/prod/pvp/',
    homework:
      'https://cmxtughsd8.execute-api.cn-north-1.amazonaws.com.cn/prod/',
    ladder:
      'https://gjopq8oyif.execute-api.cn-north-1.amazonaws.com.cn/prod/ladder/',
    liveCourse:
      'https://hqjsjshijb.execute-api.cn-north-1.amazonaws.com.cn/prod/liveCourse/',
    verification:
      'https://ksraxbfxf3.execute-api.cn-north-1.amazonaws.com.cn/prod/verification/',
    hjj: 'https://nqo0qjr6b5.execute-api.cn-north-1.amazonaws.com.cn/prod/hjj/',
    hjjCourse:
      'https://axz1xgu79h.execute-api.cn-north-1.amazonaws.com.cn/prod/hjjCourse/',
    multimediaClassroom:
      'https://c5ahq7p74c.execute-api.cn-north-1.amazonaws.com.cn/prod/multimediaClassroom/',
    ec: 'https://q81m1l5kdb.execute-api.cn-north-1.amazonaws.com.cn/prod/ec/',
    ai: 'https://3a4sspk9w0.execute-api.cn-north-1.amazonaws.com.cn/prod/ai/',
  },
  cdn: 'https://cdn.weiqistar.com/',
  backstage:
    'http://backstage.hjjcn.weiqi.study.s3-website.cn-north-1.amazonaws.com.cn/',
  homepage: 'http://hjjcn.weiqi.study.s3-website.cn-north-1.amazonaws.com.cn/',
};

export default url;
